<script>
  import { onMount } from "svelte";
  import { account, appSession, appConstants } from "../stores/app.js";
  import MyModal from "../components/MyModal.svelte";
  import RestPilots from "../components/RestPilots.svelte";
  import { DateTime } from "luxon";

  let pilot = null;
  let pilotName = "";
  let pilotDOB = null;
  let busy = true;
  let myModal = null;
  let restPilots = null;
  let timeNow = DateTime.local();

  onMount(async () => {
    try {
      busy = true;
      pilot = await restPilots.GetPilots($appSession.pilotId);
      pilotName = pilot.lastname + ", " + pilot.firstname;
      if (typeof pilot.middlenames != "undefined") pilotName += " " + pilot.middlenames;
      pilotDOB = DateTime.fromISO(pilot.birthdate);
      busy = false;
    } catch (error) {
      busy = false;

      switch (error) {
        case "BadRole":
        case "BadRealm":
          appSession.set({ authorisationToken: null, pilotId: null });
          break;
        case "NetworkError":
          myModal.showAlert(
            "Network error",
            "A network error occurred.<p> Check network connection and try again.</p>"
          );
          break;
        default:
          myModal.showAlert("Error", error);
          break;
      }
    }
  });
</script>

<style>
  @keyframes pulse-frames {
    0% {
      /*       OLDtransform: scale(0.80); */
      transform: rotate(0deg);
      /*       opacity: 0.25; */
    }
    50% {
      /*       opacity: 0.5; */
      transform: rotate(0deg);
    }
    75% {
      /*       opacity: 0.5; */
      transform: rotate(359deg);
    }
    100% {
      /*       opacity: 1; */
      /*       OLDtransform: scale(0.9); */
      transform: rotate(359deg);
    }
  }
  .pulse {
    /*     OFFmargin-left: auto;
    OFFmargin-right: auto; */
      animation: pulse-frames 4s ease-in-out infinite;
    -webkit-animation: pulse-frames 4s ease-in-out infinite; 
  }
</style>

{#if busy}
  <div
    style="display: flex; justify-content: center; align-items: center; height: 50px; width: 100%; margin-top: 100px;">
    <div class="preloader-wrapper small active">
      <div class="spinner-layer spinner-green-only">
        <div class="circle-clipper left">
          <div class="circle" />
        </div>
        <div class="gap-patch">
          <div class="circle" />
        </div>
        <div class="circle-clipper right">
          <div class="circle" />
        </div>
      </div>
    </div>
  </div>
{:else}

  <div style="display: flex; flex-direction: row; content-align: center; align-items: center; margin-top: 20px; width: 100%;">
    <div
      style="width: 50%; box-sizing: border-box; padding: 5px; display: flex; flex-direction: row; justify-content:
      center;">
      {#if pilot && pilot.photo}
        <img
          src={pilot.photo.url}
          style="width: 140px; height: 140px;"
          alt="" />
      {:else}
        <img src="assets/crew-placeholder.png" style="width: 140px; height: 140px;" alt="" />
      {/if}
    </div>

    <div style="width: 50%; box-sizing: border-box; text-align: center;">
      <div style="font-size: 1.2em; font-weight: bold;">
        JumpHub
        <br />
        Approved
      </div>
      <div OFFclass="pulse">
        <img src="assets/approved-tick.svg" alt="" class="pulse" style="margin-top: 10px; margin-bottom: 10px; width: 80px; height: 80px;" OFFstyle="width: 40%; max-width: 80px;" />
      </div>
      <div style="font-size: 0.9em;">{timeNow.toFormat('MM/dd/yyyy')}</div>
    </div>
  </div>

  <div style="text-align: center; font-weight: 600; margin-top: 20px; font-size: 1.1em;">{pilotName.toUpperCase()}</div>

  <div style="text-align: center; font-weight: 600; margin-top: 5px;">
    DOB: {pilotDOB && pilotDOB.toFormat('MM/dd/yyyy')}
  </div>

  <div
    style="text-align: center; display: flex; flex-direction: row; justify-content: center; align-items: center;
    margin-top: 10px;">
    {#if pilot.cassrated == 1}
      <div style="margin-left: 10px; margin-right: 20px;">
        CASS
        <i class="material-icons">done</i>
      </div>
    {/if}

    {#if pilot.kcmrated == 1}
      <div style="margin-left: 10px; margin-right: 20px;">
        KCM
        <i class="material-icons">done</i>
      </div>
    {/if}
  </div>

  <div style="margin-top: 20px; text-align: center; font-weight: bold;">{pilot && pilot.operator.name}</div>
  <div style="text-align: center; font-size: 0.9em;">{pilot && pilot.operator.phone}</div>
  {#if pilot.employeeid}
    <div style="text-align: center; font-size: 0.9em;">EMPLOYEE NO. {pilot.employeeid.toUpperCase()}</div>
  {/if}

  <div style="margin-top: 40px; text-align: center; font-size: 0.85em;">
    <b>IMPORTANT</b>
    <br />
    Crew must also present:
    <br />
    A valid Company ID
    <br />
    License
    <br />
    Medical
    <br />
    Other ID if required by an operator
  </div>
{/if}

<MyModal bind:this={myModal} />
<RestPilots bind:this={restPilots} />
